import { render, staticRenderFns } from "./faq_liaoban.vue?vue&type=template&id=4ad1365f&scoped=true&"
import script from "./faq_liaoban.vue?vue&type=script&lang=js&"
export * from "./faq_liaoban.vue?vue&type=script&lang=js&"
import style0 from "./faq_liaoban.vue?vue&type=style&index=0&id=4ad1365f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad1365f",
  null
  
)

export default component.exports